export default __webpack_public_path__ + "static/media/output.4a9c9e8b.webm";